// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    ItemResponse,
    ItemResponseFromJSON,
    ItemResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface Section
 */
export interface Section {
    /**
     * 
     * @type {string}
     * @memberof Section
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Section
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof Section
     */
    order: number;
    /**
     * 
     * @type {Array<ItemResponse>}
     * @memberof Section
     */
    items: Array<ItemResponse>;
}

export function SectionFromJSON(json: any): Section {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'order': json['order'],
        'items': (json['items'] as Array<any>).map(ItemResponseFromJSON),
    };
}

export function SectionToJSON(value?: Section): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'title': value.title,
        'order': value.order,
        'items': (value.items as Array<any>).map(ItemResponseToJSON),
    };
}


